export var CalloutContentStyles = function CalloutContentStyles(props) {
  var theme = props.theme;
  var effects = theme.effects;
  return {
    root: {
      borderRadius: effects.roundedCorner2,
      borderWidth: 0,
      boxShadow: effects.elevation16,
      selectors: {
        '&.ms-Tooltip, &.ms-ComboBox-callout': {
          boxShadow: effects.elevation8
        }
      }
    },
    beakCurtain: {
      borderRadius: effects.roundedCorner2
    },
    calloutMain: {
      borderRadius: effects.roundedCorner2
    }
  };
};